import shop from '~/lib/api/shop';
import { ShopTypes } from '~/lib/data-contract';
import shopErrors from '~/services/shop/errors';
import { getUrl } from '~/services/shop/utils';

type Args = {
    name: string | null;
    phoneNumber: string | null;
    token: string | null;
};

export default function setCustomUserProfile({ name, phoneNumber, token }: Args) {
    if (!name && !phoneNumber) {
        return Promise.reject(new Error(shopErrors.referenceNotFound.message));
    }

    const url = getUrl('/customers/users/me');

    return shop
        .put(url, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            json: { name, phoneNumber },
        })
        .json<ShopTypes.UserInformationDto>();
}
